const dashedId = (str) => str.replace(/([:;[\]().,'?!])/g, '').replace(/\s/g, '-').toLowerCase();

export default dashedId;
